import favicon from '../../assets/favicon/favicon-bbseguros.ico';
import BancoDoBrasilTextosBold from '../../assets/fonts/BancoDoBrasilTextos-Bold.ttf';
import BancoDoBrasilTextosLight from '../../assets/fonts/BancoDoBrasilTextos-Light.ttf';
import BancoDoBrasilTextosMedium from '../../assets/fonts/BancoDoBrasilTextos-Medium.ttf';
import BancoDoBrasilTextosRegular from '../../assets/fonts/BancoDoBrasilTextos-Regular.ttf';
import BancoDoBrasilTextosXBold from '../../assets/fonts/BancoDoBrasilTextos-XBold.ttf';
import BancoDoBrasilTitulosBold from '../../assets/fonts/BancoDoBrasilTitulos-Bold.ttf';
import BancoDoBrasilTitulosLight from '../../assets/fonts/BancoDoBrasilTitulos-Light.ttf';
import BancoDoBrasilTitulosMedium from '../../assets/fonts/BancoDoBrasilTitulos-Medium.ttf';
import BancoDoBrasilTitulosRegular from '../../assets/fonts/BancoDoBrasilTitulos-Regular.ttf';
import BancoDoBrasilTitulosXBold from '../../assets/fonts/BancoDoBrasilTitulos-XBold.ttf';
import InterBold from '../../assets/fonts/Inter-Bold.ttf';
import InterExtraBold from '../../assets/fonts/Inter-ExtraBold.ttf';
import InterLight from '../../assets/fonts/Inter-Light.ttf';
import InterMedium from '../../assets/fonts/Inter-Medium.ttf';
import InterRegular from '../../assets/fonts/Inter-Regular.ttf';
import { ReactComponent as LogoBBSegurosHeader } from '../../assets/images/logoBBSegurosHeader.svg';

const bb = {
  id: 'bb',
  displayName: 'BB Seguros | Área do Cliente',
  envAreaLogada: 'REACT_APP_ANGULAR_URI',
  header: {
    logo: LogoBBSegurosHeader,
    logoUrl: '//www.bbseguros.com.br',
  },
  favicon,
  gtmId: 'GTM-TW684H6',
  colors: {
    primary: '#465EFF',
    primaryDark: '#5A6FFF',
    primaryLight: '#0a67a2',
    secondary: '#FCFC30',
    textPrimary: '#4C4C4C',
    error: '#F44336',
    surface: '#FFFFFF',
    background: '#F3EEFB',
    backgroundPrimary: '#3751FF',
    backgroundSecondary: '#F3EEFB',
    backgroundDark: '#4E4E4E',
    success: '#4CAF50',
    warning: '#FF9800',
    info: '#2196F3',
    textSecondary: '#4C4C4C',
    textDisabled: '#BDBDBD',
    border: '#E0E0E0',
    borderPrimary: '#C1D1F1',
    divider: '#FCEE4F',
    focus: '#465EFF',
    hover: '#465EFF',
    inverted: '#FFFFFF',
  },
  typography: {
    fontFamily: 'BancoDoBrasilTextos, sans-serif',
    fontFamilyTitle: 'BancoDoBrasilTitulos, sans-serif',
    inputLabelFontFamily: 'Inter, sans-serif',
    inputFieldFontFamily: 'Inter, sans-serif',
    descriptionFontFamily: 'Inter, sans-serif',
    textFontFamilyMap: {
      primary: {
        regular: 'BancoDoBrasilTextos, sans-serif',
        medium: 'BancoDoBrasilTextos, sans-serif',
        bold: 'BancoDoBrasilTitulos, sans-serif',
      },
      secondary: {
        regular: 'BancoDoBrasilTitulos, sans-serif',
        medium: 'BancoDoBrasilTitulos, sans-serif',
        bold: 'BancoDoBrasilTitulos, sans-serif',
      },
      tertiary: {
        bold: 'Inter, sans-serif',
        regular: 'Inter, sans-serif',
        medium: 'Inter, sans-serif',
        italic: 'Inter, sans-serif',
        semibold: 'Inter, sans-serif',
      },
    },
    weights: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    fonts: [
      {
        family: 'BancoDoBrasilTextos',
        weight: 300,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosLight}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 400,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosRegular}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 500,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosMedium}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 700,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosBold}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTextos',
        weight: 900,
        style: 'normal',
        src: `url(${BancoDoBrasilTextosXBold}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 300,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosLight}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 400,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosRegular}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 500,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosMedium}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 700,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosBold}) format('truetype')`,
      },
      {
        family: 'BancoDoBrasilTitulos',
        weight: 900,
        style: 'normal',
        src: `url(${BancoDoBrasilTitulosXBold}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 300,
        style: 'normal',
        src: `url(${InterLight}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 400,
        style: 'normal',
        src: `url(${InterRegular}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 500,
        style: 'normal',
        src: `url(${InterMedium}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 700,
        style: 'normal',
        src: `url(${InterBold}) format('truetype')`,
      },
      {
        family: 'Inter',
        weight: 900,
        style: 'normal',
        src: `url(${InterExtraBold}) format('truetype')`,
      },
    ],
  },
  screens: {
    login: {
      title: '#5A6FFF',
      underlineText: '#FCFC30',
      SingleCardAccess: {
        title: {
          color: '#3751FF',
          fontSize: '14px',
        },
        btnText: {
          color: '#3751FF',
          fontSize: '18px',
        },
        backgroundColor: '#F9F7FF',
        border: '#DDE4FC',
        link: '#465EFF',
      },
      CardLogin: {
        btnAcessarBackground: '#FFFFFF',
        btnAcessarBackgroundHover: 'rgba(70, 94, 255, 0.04)',
        btnAcessarText: '#465EFF',
      },
    },
    primeiroAcesso: {
      title: '#8891CC',
      background: '#edf0f4',
    },
    senhaPrimeiroAcesso: {
      title: '#8891CC',
      text: '#4C4C4C',
      info: '#4D4D4D',
    },
    usuarioValidadoPage: {
      titulo: '#8891CC',
      background: '#F3EEFB',
      containerGrid: {
        background: '#FFFF',
      },
    },
    selecaoEnvioCodigoPrimeiroAcesso: {
      texts: {
        title: 'Primeiro Acesso',
        subtitleEmailOnly: 'Você receberá o código por e-mail.',
        subtitleWithPhone: 'Como deseja receber seu código de acesso?',
        labelEmail: 'Receber por e-mail:',
        labelSms: 'Receber por SMS:',
        button: 'CONTINUAR',
      },
      title: '#8891CC',
      subtitle: '#4C4C4C',
      background: '#edf0f4',
      cardBackground: '#FFFFFF',
      selectOption: {
        border: '#CAD0F8',
        selectedBorder: '#465EFF',
        labelColor: '#8891CC',
        selectedLabelColor: '#465EFF',
        dataColor: '#4C4C4C',
      },
    },
    confirmacaoSeguranca: {
      titulo: '#8891CC',
      link: '#465EFF',
      background: '#edf0f4',
      containerGrid: {
        background: '#FFFF',
      },
    },
    esqueciSenhaEmail: {
      title: '#8891CC',
    },
    redefinirSenha: {
      titulo: '#8891CC',
      link: '#465EFF',
      background: '#EDF0F4',
      formContainer: '#FFFF',
      iconeVisibility: '#0A67A2',
    },
  },
  components: {
    header: {
      background: '#FCEE4F',
    },
    customButton: {
      background: '#465EFF',
      text: '#FFFFFF',
      textTransform: 'none',
    },
    radioGroup: {
      checked: '#465EFF',
    },
    customDatePicker: {
      border: '#DDE4FC',
      icon: '#465EFF',
      calendar: {
        headerBackground: '#465EFF',
        headerText: '#FFFFFF',
        daySelected: '#465EFF',
        daySelectedText: '#FFFFFF',
      },
    },
    title: {},
    MuiInputBase: {
      inputColor: '#FF0000',
    },
    MuiOutlinedInput: {
      inputShadow: '0 0 0 100px #fff inset',
    },
    input: {
      border: '#DDE4FC',
      icon: '#465EFF',
    },
    customModal: {
      title: '#8891CC',
    },
  },
};

export default bb;
